import { shouldNotForwardProps } from '@/core/helpers';
import { styled } from '../muiReexports';
import { TabPanel } from './TabPanel';
export const DialogTabPanel = styled(TabPanel, shouldNotForwardProps('noBottomPadding'))(({ theme, noBottomPadding }) => ({
    height: '100%',
    paddingTop: theme.spacing(1),
    paddingBottom: noBottomPadding ? theme.spacing(2) : theme.spacing(8),
}));
